/**
 * Bitcoin utility functions.
 */

import { satoshisToBitcoins } from '@caravan/bitcoin';

export function satsToBtc(sats: number): string {
  return Number(satoshisToBitcoins(sats.toString())).toFixed(8);
}

export function formatBtc(sats: number): string {
  return `${satsToBtc(sats)} BTC`;
}
